import { createSlice } from '@reduxjs/toolkit';

export const vehicleSlice = createSlice({
  name: 'vehicle',
  initialState: {
    vehicles: [],
  },
  reducers: {
    addVehicle: (state, action) => {
      state.vehicles = action.payload
    },
  },
});

export const { addVehicle } = vehicleSlice.actions;

export const selectVehicles = state => state.vehicle.vehicles;

export default vehicleSlice.reducer;
